import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { math } from 'polished'
import { RAIL_HEIGHT, HANDLE_SIZE } from '../constants'

const railStyle = `
  position: absolute;
  width: 100%;
  transform: translate(0%, -50%);
  border-radius: ${math(`${RAIL_HEIGHT} / 2`)};
`

const OuterRail = styled.div`
  ${railStyle}
  height: ${HANDLE_SIZE};
  cursor: pointer;
`

const InnerRail = styled.div`
  ${railStyle}
  height: ${RAIL_HEIGHT};
  pointer-events: none;
  background-color: rgb(155, 155, 155);
`

const Rails = ({ getRailProps }) => (
  <React.Fragment>
    <OuterRail {...getRailProps()} />
    <InnerRail />
  </React.Fragment>
)

Rails.propTypes = {
  getRailProps: PropTypes.func.isRequired,
}

export default Rails
